import { useEffect, useState } from "react";

// Comma-separated input that keeps the RAW text while typing so users can freely
// type "gaming, music" (commas + spaces) without the value being reshuffled or the
// cursor jumping mid-type. Parses to a clean array for the parent on every change.
export function CsvField({ value, onChange, as = "input", ...props }) {
  const joined = (value || []).join(", ");
  const [text, setText] = useState(joined);

  useEffect(() => {
    const parsed = text.split(",").map((x) => x.trim()).filter(Boolean).join(", ");
    if (joined !== parsed) setText(joined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [joined]);

  const handle = (e) => {
    const raw = e.target.value;
    setText(raw);
    onChange(raw.split(",").map((x) => x.trim()).filter(Boolean));
  };

  const Comp = as;
  return <Comp value={text} onChange={handle} {...props} />;
}
